import React from 'react';
import { TextButton } from '@riac/design-system';
import {
  ICatalogSearch, ISearchInput, ISolrSearchResult,
  TLessWordSearches,
  TSpellcheck,
} from 'src/pages/CatalogPage/CatalogPage.i';
import { NoResultsStyles } from 'src/pages/CatalogPage/components/HandleNoResults/HandleNoResults.style';
import { ICatalogPageState } from 'src/pages/CatalogPage/CatalogPage';

interface ICorrections {
  searchInput: ISearchInput;
  searchResult: ICatalogPageState;
  updateSearch: ICatalogSearch;
  searchBusy: boolean;
}

export const HandleNoResults = ({ searchInput, searchResult, updateSearch, searchBusy }: ICorrections) => {
  function onSpellCheckResultClick(resultName: string): void {
    updateSearch({ keywords: resultName });
  }

  if((searchResult.totalResults > 0) || (searchBusy == true)) {
    return null;
  }
  return (
    <NoResultsStyles>
      <div>
        {searchInput.onlyLotsBidOn && !searchInput.keywords
          && <>
            <p>
              You have not bid on any lots. Please uncheck the "Include Only Lots Bid On" filter and start bidding!
            </p>
          </>
          || <>
            <p>
              We did not find any results for {`"${searchInput.keywords}"`}
            </p>
            <div>
              <strong>Suggestions</strong>
              <ul>
                <li>Check your spelling</li>
                <li>Try different words with the same meaning</li>
                {(searchResult.spellcheck.length > 0) && (<li>Try one of the following searches:</li>)}
              </ul>
            </div>
            <ul className="suggestionsContainer">
              {(searchResult.spellcheck.length > 0)

                && searchResult.spellcheck.map((sc) => (
                  <li key={sc.name}>
                    <TextButton blueText onPress={() => onSpellCheckResultClick(sc.name)}>
                      {sc.name} ({sc.hits} Found)
                    </TextButton>
                  </li>
                ))
              }
            </ul>
          </>}
        {searchResult.spellcheck.length > 0 && searchResult.lessWordSearches.length > 0 && (
          <p>
            Or, try using less keywords:
          </p>
        )}
        <ul className="suggestionsContainer">
          {searchResult.lessWordSearches
            .sort((a, b) => b.resultCount - a.resultCount)
            .map((lws) => (
              <li key={lws.keyword}>
                <TextButton blueText onPress={() => onSpellCheckResultClick(lws.keyword)}>
                  {lws.keyword.toLowerCase()} ({lws.resultCount} Found)
                </TextButton>
              </li>
            ))}
        </ul>
        <p>
          If you still can't find what you're looking for, please reach out through
          {' '}
          <TextButton blueText to="/contact">our contact page</TextButton> and we'll be happy to help.
        </p>
      </div>
    </NoResultsStyles>
  );
};
